import { render, staticRenderFns } from "./FavouriteWh.vue?vue&type=template&id=d41322e4"
import script from "./FavouriteWh.vue?vue&type=script&lang=js"
export * from "./FavouriteWh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports